import { URL as API_BASE } from '../../variables';
export async function portalRequest(faculdade, token, path = '', method = 'GET', data) {
  const endpoint = `${API_BASE}api/faculdade/portal/${faculdade}/${path}`;
  const form = data instanceof FormData,
    headers = {
      Accept: 'application/json',
      Authorization: `Bearer ${token}`,
    };
  if (data && !form) headers['Content-Type'] = 'application/json';
  const response = await fetch(endpoint, {
    method,
    headers,
    body: data ? (form ? data : JSON.stringify(data)) : undefined,
  });
  if (response.status === 204) return null;
  const json = await response.json().catch(() => null);
  if (!response.ok) {
    const error = new Error(
      json?.message || json?.error?.message || 'Não foi possível concluir a operação.'
    );
    error.fields = json?.errors || {};
    throw error;
  }
  return json;
}
export const portalList = (fac, token, path, filters = {}) =>
  portalRequest(
    fac,
    token,
    path +
      '?' +
      new URLSearchParams(Object.entries(filters).filter(([, v]) => v !== '' && v != null))
  );
export async function portalFile(fac, token, path) {
  const response = await fetch(`${API_BASE}api/faculdade/portal/${fac}/${path}`, {
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: 'application/pdf,application/octet-stream,application/json',
    },
  });
  if (!response.ok) {
    const body = await response.json().catch(() => null);
    throw new Error(body?.message || 'Não foi possível baixar o arquivo.');
  }
  return response.blob();
}
